export const DEFAULT_ORGANIZATION_LOGO =
  '/img/crm/sidebar/default-organization.jpg';
